import axiosInstance from "../../utils/axiosInstance";
import { getAuthHeaders } from "../../utils/authHeader";

const BASE_URL = `/assistant`;

export const fetchAllAssistant = async () => {
  const res = await axiosInstance.get(`${BASE_URL}`, getAuthHeaders());
  return res.data;
};

export const fetchAssistant = async (uuid) => {
  const res = await axiosInstance.get(`${BASE_URL}/${uuid}`, getAuthHeaders());
  return res.data;
};

export const updateAssistant = async (uuid, data) => {
  const res = await axiosInstance.put(
    `${BASE_URL}/${uuid}`,
    data,
    getAuthHeaders(),
  );
  return res.data;
};

export const fetchAllAssistants = async (accountId) => {
  const res = await axiosInstance.get(
    `${BASE_URL}/account/${accountId}`,
    getAuthHeaders(),
  );
  return res.data;
};

export const createAssistant = async (data) => {
  const res = await axiosInstance.post(BASE_URL, data, getAuthHeaders());
  return res.data;
};

export const deleteAssistant = async (uuid) => {
  const res = await axiosInstance.delete(
    `${BASE_URL}/${uuid}`,
    getAuthHeaders(),
  );
  return res.data;
};

export const updateAssistantKnowledgeBase = async (uuid, data) => {
  const res = await axiosInstance.put(
    `${BASE_URL}/knowledge-base/${uuid}`,
    data,
    getAuthHeaders(),
  );
  return res.data;
};

export const updateAssistantSettings = async (uuid, data) => {
  const res = await axiosInstance.put(`${BASE_URL}/settings/${uuid}`, data);
  return res.data;
};

export const updateAssistantNumber = async (uuid, data) => {
  const res = await axiosInstance.put(
    `${BASE_URL}/phone-number/${uuid}`,
    data,
    getAuthHeaders(),
  );
  return res.data;
};

export const removeAssistant = async () => {
  const res = await axiosInstance.post(
    `${BASE_URL}/remove`,
    {},
    getAuthHeaders(),
  );
  return res.data;
};

export const startComposioAuth = async (data) => {
  const res = await axiosInstance.post(
    `/composio/auth`,
    data,
    getAuthHeaders(),
  );
  return res.data;
};
